export default __webpack_public_path__ + "static/media/nav_logo.8689a24a.png";